import { useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { trackEvent } from "../lib/track";

// Favorites: the unlimited "loved it" collection. Independent of My List and Top 8.
export function useFavorites() {
  const { user, patchUser } = useAuth();
  const list = (user && user.favorites) || [];

  const inList = useCallback((id) => list.includes(id), [list]);

  const toggle = useCallback(
    async (item) => {
      const id = typeof item === "string" ? item : item.id;
      const title = typeof item === "string" ? "Title" : item.title;
      const has = list.includes(id);
      const next = has ? list.filter((x) => x !== id) : [...list, id];
      patchUser({ favorites: next }); // optimistic
      try {
        if (has) {
          await api.delete(`/favorites/${id}`);
          toast(`Removed "${title}" from Favorites`);
        } else {
          await api.post("/favorites", { id });
          trackEvent("favorite_add", { title_id: id });
          toast(`❤ Added "${title}" to Favorites`);
        }
      } catch {
        patchUser({ favorites: list }); // revert
        toast.error("Could not update Favorites");
      }
    },
    [list, patchUser]
  );

  return { list, inList, toggle };
}
